// 쇼링장 전용 포탈 — 본인 배차 수신 + 차량별 쇼링·면장용 사진 업로드 (배차 D4, 2026-06-02)
//   백엔드: routes/shoringPortal.js (GET /shoring/me, /shoring/dispatches, /:id, POST /:id/cars/:carId/photo)
import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';

var NAVY = '#1B3A5C';
var ST_COLOR = { '전달': '#2563eb', '운송중': '#ea580c', '완료': '#16a34a' };
var IMG_BASE = (API || '').replace(/\/api\/?$/, '');

function ShoringPortal({ showToast, user }) {
  var st = showToast || function () {};
  var meState = useState(null); var me = meState[0]; var setMe = meState[1];
  var listState = useState([]); var list = listState[0]; var setList = listState[1];
  var detailState = useState(null); var detail = detailState[0]; var setDetail = detailState[1];
  var busyState = useState(0); var busyCar = busyState[0]; var setBusyCar = busyState[1];

  function loadMe() { authFetch(API + '/shoring/me').then(function (r) { return r.json(); }).then(function (d) { if (d && d.success) setMe(d); }).catch(function () {}); }
  function loadList() { authFetch(API + '/shoring/dispatches').then(function (r) { return r.json(); }).then(function (d) { if (d && d.success) setList(d.items || []); }).catch(function () {}); }
  useEffect(function () { loadMe(); loadList(); }, []);

  function openDetail(id) { authFetch(API + '/shoring/dispatches/' + id).then(function (r) { return r.json(); }).then(function (d) { if (d && d.success) setDetail(d.dispatch); }).catch(function () {}); }
  function uploadPhoto(carId, file) {
    if (!file) return;
    setBusyCar(carId);
    var fd = new FormData(); fd.append('photo', file);
    authFetch(API + '/shoring/dispatches/' + detail.id + '/cars/' + carId + '/photo', { method: 'POST', body: fd })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        setBusyCar(0);
        if (d && d.success) { st('사진 업로드됨', ''); openDetail(detail.id); loadList(); }
        else st((d && d.error) || '업로드 실패', 'err');
      }).catch(function () { setBusyCar(0); st('업로드 실패', 'err'); });
  }

  var counts = (me && me.counts) || { 전달: 0, 운송중: 0, 완료: 0 };
  var yardName = (me && me.yard && me.yard.name) || (user && user.name) || '쇼링장';
  return (
    <div style={{ padding: 20, maxWidth: 1000, margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12, marginBottom: 16 }}>
        <div>
          <div style={{ fontSize: 22, fontWeight: 800, color: NAVY }}>{'🏭 ' + yardName}</div>
          <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>{'배차 수신 · 쇼링/면장용 사진 업로드 포털'}</div>
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          {[['전달', '#2563eb'], ['운송중', '#ea580c'], ['완료', '#16a34a']].map(function (k) {
            return <div key={k[0]} style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: '8px 16px', textAlign: 'center' }}>
              <div style={{ fontSize: 11, color: '#64748b' }}>{k[0]}</div>
              <div style={{ fontSize: 20, fontWeight: 800, color: k[1] }}>{counts[k[0]] || 0}</div></div>;
          })}
        </div>
      </div>

      <div style={{ overflowX: 'auto', border: '1px solid #e5e7eb', borderRadius: 10, background: '#fff' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead><tr style={{ background: '#f8fafc', color: '#475569' }}>
            <th style={thS}>{'배차번호'}</th><th style={thS}>{'캐리어'}</th><th style={thS}>{'픽업일'}</th>
            <th style={thC}>{'차량'}</th><th style={thC}>{'사진'}</th><th style={thC}>{'상태'}</th><th style={thC}>{'처리'}</th>
          </tr></thead>
          <tbody>
            {list.length === 0 && <tr><td colSpan={7} style={{ padding: 30, textAlign: 'center', color: '#94a3b8' }}>{'배정된 배차가 없습니다'}</td></tr>}
            {list.map(function (d) {
              return (
                <tr key={d.id} style={{ borderTop: '1px solid #f1f5f9' }}>
                  <td style={Object.assign({ fontWeight: 700, color: NAVY }, tdS)}>{d.dispatch_no}</td>
                  <td style={tdS}>{d.carrierName || '-'}</td>
                  <td style={tdS}>{d.pickup_date || '-'}</td>
                  <td style={tdC}>{d.carCount}</td>
                  <td style={tdC}><span style={{ fontSize: 11, fontWeight: 700, color: d.shoringPhotoCount > 0 ? '#15803d' : '#94a3b8' }}>{'📷 ' + (d.shoringPhotoCount || 0)}</span></td>
                  <td style={tdC}><span style={{ fontSize: 11, fontWeight: 700, color: '#fff', background: ST_COLOR[d.status] || '#94a3b8', borderRadius: 10, padding: '2px 8px' }}>{d.status}</span></td>
                  <td style={tdC}><button onClick={function () { openDetail(d.id); }} style={btnGray}>{'사진 업로드'}</button></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {detail && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }} onClick={function () { setDetail(null); }}>
          <div style={{ background: '#fff', borderRadius: 14, padding: 20, width: 620, maxWidth: '94vw', maxHeight: '88vh', display: 'flex', flexDirection: 'column' }} onClick={function (e) { e.stopPropagation(); }}>
            <div style={{ fontSize: 16, fontWeight: 800, color: NAVY }}>{'배차 ' + detail.dispatch_no}</div>
            <div style={{ fontSize: 12, color: '#64748b', marginBottom: 10 }}>{'캐리어: ' + (detail.shoring_yard ? '' : '') + (detail.pickup_date ? '픽업 ' + detail.pickup_date + ' · ' : '') + '상태: ' + detail.status + ' · 차량별 쇼링/면장 사진을 업로드하세요'}</div>
            <div style={{ flex: 1, overflowY: 'auto' }}>
              {(detail.items || []).map(function (it) {
                return (
                  <div key={it.id} style={{ border: '1px solid #e5e7eb', borderRadius: 10, padding: 12, marginBottom: 10 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                      <div>
                        <span style={{ fontWeight: 700, color: NAVY, fontSize: 14 }}>{it.carNo}</span>
                        <span style={{ fontSize: 12, color: '#64748b', marginLeft: 8 }}>{it.carType}</span>
                        <span style={{ fontSize: 11, color: '#94a3b8', marginLeft: 8 }}>{'VIN ' + (it.vin || '-')}</span>
                      </div>
                      <label style={{ padding: '6px 14px', borderRadius: 8, background: busyCar === it.car_id ? '#94a3b8' : NAVY, color: '#fff', fontSize: 12, fontWeight: 700, cursor: busyCar === it.car_id ? 'default' : 'pointer' }}>
                        {busyCar === it.car_id ? '업로드 중...' : '📷 사진 추가'}
                        <input type="file" accept="image/*" capture="environment" disabled={busyCar === it.car_id} onChange={function (e) { var f = e.target.files && e.target.files[0]; uploadPhoto(it.car_id, f); e.target.value = ''; }} style={{ display: 'none' }} />
                      </label>
                    </div>
                    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                      {(it.photos || []).length === 0 && <span style={{ fontSize: 12, color: '#94a3b8' }}>{'업로드된 사진 없음'}</span>}
                      {(it.photos || []).map(function (p) {
                        return <a key={p.id} href={IMG_BASE + '/uploads/' + p.fileName} target="_blank" rel="noopener noreferrer">
                          <img src={IMG_BASE + '/uploads/' + p.fileName} alt="" style={{ width: 72, height: 72, objectFit: 'cover', borderRadius: 8, border: '1px solid #e5e7eb' }} />
                        </a>;
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
            <button onClick={function () { setDetail(null); }} style={{ marginTop: 10, padding: '8px', background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{'닫기'}</button>
          </div>
        </div>
      )}
    </div>
  );
}

var thS = { padding: '10px 12px', textAlign: 'left', fontWeight: 700, fontSize: 12 };
var thC = Object.assign({}, thS, { textAlign: 'center' });
var tdS = { padding: '9px 12px', color: '#334155' };
var tdC = Object.assign({}, tdS, { textAlign: 'center' });
var btnGray = { padding: '4px 12px', border: '1px solid #cbd5e1', background: '#f8fafc', color: '#475569', borderRadius: 6, fontSize: 11, fontWeight: 600, cursor: 'pointer' };

export default ShoringPortal;
